import React, { useState, useEffect } from "react"
import { Link } from "gatsby"

import DesktopStyles from "./desktop-nav.module.scss"

const DesktopNav = ({ darkLogo }) => {
  const [scrollPosition, setScrollPosition] = useState(0)

  const handlePageScroll = () => {
    let currentScrollPosition =
      window.scrollY ||
      window.scrollTop ||
      document.body.scrollTop ||
      document.documentElement.scrollTop ||
      document.getElementsByTagName("html")[0].scrollTop

    setScrollPosition(currentScrollPosition)
  }

  const addEventListeners = () => {}

  useEffect(() => {
    window.addEventListener("scroll", handlePageScroll)

    return () => {
      window.removeEventListener("scroll", handlePageScroll)
    }
  }, [])

  return (
    <nav
      className={`${DesktopStyles.nav} ${
        scrollPosition > 25 ? DesktopStyles.navWithBackground : null
      } ${darkLogo ? DesktopStyles.navDarkLogo : null}`}
    >
      <Link to="/" className={DesktopStyles.logo}>
        Eclipperz
      </Link>
      <Link to="/" activeClassName={DesktopStyles.active}>
        Home
      </Link>
      <Link to="/purchase/" activeClassName={DesktopStyles.active}>
        Purchase
      </Link>
      <Link to="/about/" activeClassName={DesktopStyles.active}>
        About
      </Link>
      <Link to="/competitions/" activeClassName={DesktopStyles.active}>
        Competitions
      </Link>
    </nav>
  )
}

export default DesktopNav
